import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { CommentBookmarkDeleteAction } from '../../types';
import { getContentObjectRepliesQueryKey } from '../keys';
import type { GetContentObjectRepliesQuery } from '../use-content-object-replies-query';

/**
 * @deprecated Introduced as part of the #87353 feed refactor to manually patch the React Query cache
 * after each mutation. This ad-hoc cache-patching approach needs a better long-term solution.
 */
export const useDeleteComment = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ contentObjectId, id }: CommentBookmarkDeleteAction) => {
      let numberOfDeletedReplies = 0;

      queryClient.setQueriesData<GetContentObjectRepliesQuery>(
        { queryKey: getContentObjectRepliesQueryKey({ id: contentObjectId }) },
        (replies) =>
          replies?.flatMap((reply) => {
            if (reply.id === id) {
              numberOfDeletedReplies = reply.replies?.length ?? 0;
              return [];
            }

            if (reply.replies) {
              return [
                {
                  ...reply,
                  replies: reply.replies.filter((child) => child.id !== id),
                },
              ];
            }

            return [reply];
          }),
      );

      return numberOfDeletedReplies;
    },
    [queryClient],
  );
};
